import React, {Component} from 'react';
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import LoginForm from './LoginForm'
import * as userActions from '../actions/UserActions';


class LoginPage extends Component {
    componentDidMount() {
      this.props.resetForm();
    }

    translate = () => {
      const keys = Object.keys(this.props.translations).map((translation) => translation);
      return this.props.translate(keys);
    }

    render() {
        const { login, navigateToPasswordResetPage } = this.props.userActions;

        return (
            <LoginForm
                onSubmit={login}
                navigateToPasswordResetPage={navigateToPasswordResetPage}
                translations={this.translate()}
            />
        )
    }
}

function mapStateToProps(state) {
    return {
      translations: state.locale.translations,
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code
    };
}

function mapDispatchToProps(dispatch) {
    return {
        resetForm: () => dispatch({ type: 'RESET_FORM' }),
        userActions: bindActionCreators(userActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)



// WEBPACK FOOTER //
// ./src/components/LoginPage.js